module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-customers",
    attrs: {
      "value": _vm.basicAccountList,
      "paginator": true,
      "rows": 8,
      "data-key": "id",
      "editMode": "cell"
    }
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n          " + _vm._s(slotProps.index + 1) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Transaction Code",
      "field": "transactionCode",
      "sortable": true
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Account",
      "sortable": true,
      "field": "accountMasterId"
    },
    scopedSlots: _vm._u([{
      key: "editor",
      fn: function(slotProps) {
        return [_c('Dropdown', {
          attrs: {
            "options": _vm.accountMasterLists,
            "optionLabel": "name",
            "optionValue": "id",
            "placeholder": "Select Account"
          },
          on: {
            "change": function($event) {
              return _vm.updateBasicAccountSetUp(slotProps.data)
            }
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function(slotProps) {
              return [_c('span', {
                class: 'product-badge status-'
              }, [_vm._v(_vm._s(slotProps.option.name))])]
            }
          }], null, true),
          model: {
            value: (slotProps.data['accountMasterId']),
            callback: function($$v) {
              _vm.$set(slotProps.data, 'accountMasterId', $$v)
            },
            expression: "slotProps.data['accountMasterId']"
          }
        })]
      }
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n          " + _vm._s(slotProps.data.accountMasterId.name) + "\n        ")]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03768f82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/settings/BasicAccountSetup.vue
// module id = 2008
// module chunks = 0